import { get, flow } from 'lodash/fp';
import { createStructuredSelector } from 'reselect';

const getIsFormSubmittedSuccessfully = flow(
  get(['emailSubscription', 'ui', 'submitSuccess']),
  Boolean,
);

const getCmsDescription = get([
  'layout',
  'footer',
  'result',
  'emailSubscriptionContent',
]);

export default createStructuredSelector({
  isFormSubmittedSuccessfully: getIsFormSubmittedSuccessfully,
  cmsDescription: getCmsDescription,
});
